<template>
  <div class="page-content">
    <div class="page-header">
      <div>
        <BreadcrumbComponent :items="items" />
        <h1 class="page-title">Rapport par Agent</h1>
      </div>
    </div>

    <PreloaderComponent :enable="enable" />

    <div v-if="enable">
      <!-- Filters -->
      <v-card flat class="filter-card mb-4">
        <v-card-text class="py-3">
          <v-row align="center" dense>
            <v-col cols="12" sm="6" md="3">
              <v-select :items="stores" item-value="id" item-text="name" placeholder="Emplacement" v-model="store_id" outlined dense hide-details clearable></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-select :items="devices" item-value="id" item-text="name" placeholder="Appareil" v-model="device_id" outlined dense hide-details clearable></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="auto">
              <div class="d-flex gap-2">
                <v-btn color="primary" depressed small @click="filter" :loading="loading" class="mr-1"><v-icon small>mdi-check</v-icon></v-btn>
                <v-btn outlined small @click="reset" :loading="loading" class="mr-1"><v-icon small>mdi-refresh</v-icon></v-btn>
                <v-btn color="error" outlined small @click="exportPDF" class="mr-1"><v-icon small>mdi-file-pdf-box</v-icon></v-btn>
                <v-btn color="success" outlined small @click="exportExcel"><v-icon small>mdi-file-excel</v-icon></v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Table -->
      <v-card flat class="table-card">
        <div class="table-responsive">
          <table class="report-table">
            <thead>
              <tr>
                <th class="text-left">AGENT</th>
                <th class="text-center">TAUX (%)</th>
                <th class="text-right">VENTES HTG</th>
                <th class="text-right">VENTES USD</th>
                <th class="text-right">CONVERSION ({{ currencyLabel }})</th>
                <th class="text-right">COMMISSION ({{ currencyLabel }})</th>
              </tr>
              <tr class="totals-row">
                <th class="text-left">TOTAL ({{ rows.length }} agents)</th>
                <th></th>
                <th class="text-right">{{ totals.htg | formatNumber }}</th>
                <th class="text-right">{{ totals.usd | formatNumber }}</th>
                <th class="text-right">{{ totals.conversion | formatNumber }}</th>
                <th class="text-right">{{ totals.commission | formatNumber }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(agent, idx) in rows" :key="idx">
                <td class="text-left font-weight-medium">{{ agent.name }}</td>
                <td class="text-center">{{ agent.commission }}%</td>
                <td class="text-right">{{ agent.sales_htg | formatNumber }}</td>
                <td class="text-right">{{ agent.sales_usd | formatNumber }}</td>
                <td class="text-right font-weight-bold">{{ agent.conversion | formatNumber }}</td>
                <td class="text-right">
                  <v-chip x-small color="success" dark>{{ agent.calculated_commission | formatNumber }}</v-chip>
                </td>
              </tr>
              <tr v-if="rows.length === 0">
                <td colspan="6" class="text-center text--secondary pa-6">Aucune donnée pour cette période</td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import BreadcrumbComponent from '../components/BreadcrumbComponent.vue'
import PreloaderComponent from '../components/PreloaderComponent.vue'

export default {
  name: 'AgentsReportView',
  components: { BreadcrumbComponent, PreloaderComponent },
  data: () => ({
    items: [{ text: 'Rapport Agents', disabled: false, href: '/agents' }],
    rows: [],
    enable: false,
    loading: false,
    filter_rate_id: 1,
    store_id: '',
    device_id: '',
    business_id: 0,
    stores: [],
    devices: [],
    users: [],
  }),

  computed: {
    currencyLabel() { return this.filter_rate_id == 1 ? 'HTG' : 'USD' },
    totals() {
      var t = { htg: 0, usd: 0, conversion: 0, commission: 0 }
      this.rows.forEach(function (r) {
        t.htg += r.sales_htg; t.usd += r.sales_usd
        t.conversion += r.conversion; t.commission += r.calculated_commission
      })
      return t
    }
  },

  methods: {
    getDateParams() {
      var isValid = function (v) { return v && v !== 'null' && v.trim() !== '' }
      return {
        from: isValid(localStorage.debut_periode) ? localStorage.debut_periode : '',
        to: isValid(localStorage.fin_periode) ? localStorage.fin_periode : ''
      }
    },

    parseResponse(response) {
      var self = this
      self.rows = []
      Object.keys(response.data.result).forEach(function (key) {
        var agent = response.data.result[key]
        var sHTG = agent.turnover.HTG ? parseFloat(agent.turnover.HTG.amount) : 0
        var cHTG = agent.turnover.HTG ? parseFloat(agent.turnover.HTG.amount_converted) : 0
        var sUSD = agent.turnover.USD ? parseFloat(agent.turnover.USD.amount) : 0
        var cUSD = agent.turnover.USD ? parseFloat(agent.turnover.USD.amount_converted) : 0
        var conversion = self.filter_rate_id == 1 ? (sHTG + cUSD) : (sUSD + cHTG)
        var commission = conversion * parseFloat(agent.commission) / 100
        self.rows.push({ name: agent.username, commission: agent.commission, sales_htg: sHTG, sales_usd: sUSD, conversion: conversion, calculated_commission: commission })
      })
    },

    load() {
      var self = this
      var d = this.getDateParams()
      this.$axios.get('/reports/cashier?from=' + d.from + '&to=' + d.to)
        .then(function (r) { self.parseResponse(r); self.enable = true })
        .catch(function () { self.enable = true })
    },

    filter() {
      var self = this
      var d = this.getDateParams()
      var params = 'from=' + d.from + '&to=' + d.to
      // L'API cashier attend le paramètre `store` (validé contre les magasins du business)
      if (this.store_id) params += '&store=' + this.store_id
      if (this.device_id) params += '&device_id=' + this.device_id
      self.enable = false
      this.$axios.get('/reports/cashier?' + params)
        .then(function (r) { self.parseResponse(r); self.enable = true })
        .catch(function () { self.enable = true })
    },

    reset() { this.store_id = ''; this.device_id = ''; this.filter() },

    async exportPDF() {
      var self = this
      var { jsPDF } = await import('jspdf')
      var doc = new jsPDF('l', 'mm', 'a4')
      var pw = 297, ph = 210, ml = 12, mr = pw - 12, cw = mr - ml
      var biz = {}; try { biz = JSON.parse(localStorage.business) || {} } catch (e) { biz = {} }
      var d = self.getDateParams()
      var primary = [25, 65, 115], dark = [30, 41, 59], muted = [100, 116, 139], light = [248, 250, 252], border = [220, 225, 230]

      function fmt(v) { if (!v || isNaN(v)) return '0.00'; var p = Math.abs(parseFloat(v)).toFixed(2).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' '); return (parseFloat(v) < 0 ? '-' : '') + p.join('.') }

      doc.setFillColor(...primary); doc.rect(0, 0, pw, 18, 'F')
      doc.setFontSize(12); doc.setFont('helvetica', 'bold'); doc.setTextColor(255, 255, 255)
      doc.text('RAPPORT PAR AGENT', ml, 11)
      doc.setFontSize(8); doc.setFont('helvetica', 'normal'); doc.setTextColor(200, 215, 235)
      doc.text(d.from + ' — ' + d.to, mr, 8, { align: 'right' })
      if (biz.name) doc.text(biz.name, mr, 13, { align: 'right' })

      var y = 24
      var cols = [
        { label: 'AGENT', w: 50, align: 'left' },
        { label: 'TAUX (%)', w: 18, align: 'center' },
        { label: 'VENTES HTG', w: 28, align: 'right' },
        { label: 'VENTES USD', w: 28, align: 'right' },
        { label: 'CONVERSION (' + self.currencyLabel + ')', w: 30, align: 'right' },
        { label: 'COMMISSION (' + self.currencyLabel + ')', w: 30, align: 'right' },
      ]
      var totalW = cols.reduce(function (s, c) { return s + c.w }, 0)
      var scale = cw / totalW; cols.forEach(function (c) { c.w = Math.round(c.w * scale) })
      var actualW = cols.reduce(function (s, c) { return s + c.w }, 0); cols[0].w += (cw - actualW)
      var cx = ml; cols.forEach(function (c) { c.x = cx; cx += c.w })
      var rowH = 6.5

      function drawHeader() {
        doc.setFillColor(...primary); doc.rect(ml, y, cw, rowH + 1, 'F')
        doc.setFontSize(6); doc.setFont('helvetica', 'bold'); doc.setTextColor(255, 255, 255)
        cols.forEach(function (c) { var tx = c.align === 'right' ? c.x + c.w - 3 : (c.align === 'center' ? c.x + c.w / 2 : c.x + 3); doc.text(c.label, tx, y + 4.5, { align: c.align }) })
        y += rowH + 1
      }
      drawHeader()

      self.rows.forEach(function (row, idx) {
        if (y + rowH > ph - 22) { doc.addPage(); y = 12; drawHeader() }
        if (idx % 2 === 0) { doc.setFillColor(250, 251, 253); doc.rect(ml, y, cw, rowH, 'F') }
        doc.setDrawColor(...border); doc.setLineWidth(0.1); doc.line(ml, y + rowH, mr, y + rowH)
        doc.setFontSize(7); doc.setFont('helvetica', 'normal'); doc.setTextColor(...dark)
        var vals = [row.name, row.commission + '%', fmt(row.sales_htg), fmt(row.sales_usd), fmt(row.conversion), fmt(row.calculated_commission)]
        cols.forEach(function (c, i) { var tx = c.align === 'right' ? c.x + c.w - 3 : (c.align === 'center' ? c.x + c.w / 2 : c.x + 3); doc.text(vals[i], tx, y + 4.2, { align: c.align }) })
        y += rowH
      })

      // Totals
      y += 1; doc.setFillColor(...light); doc.rect(ml, y, cw, rowH + 1, 'F')
      doc.setDrawColor(...primary); doc.setLineWidth(0.4); doc.line(ml, y, mr, y)
      doc.setFontSize(7); doc.setFont('helvetica', 'bold'); doc.setTextColor(...dark)
      var t = self.totals
      doc.text('TOTAL (' + self.rows.length + ' agents)', ml + 3, y + 4.8)
      doc.text(fmt(t.htg), cols[2].x + cols[2].w - 3, y + 4.8, { align: 'right' })
      doc.text(fmt(t.usd), cols[3].x + cols[3].w - 3, y + 4.8, { align: 'right' })
      doc.text(fmt(t.conversion), cols[4].x + cols[4].w - 3, y + 4.8, { align: 'right' })
      doc.text(fmt(t.commission), cols[5].x + cols[5].w - 3, y + 4.8, { align: 'right' })

      var totalPages = doc.internal.getNumberOfPages()
      for (var p = 1; p <= totalPages; p++) {
        doc.setPage(p); doc.setDrawColor(...border); doc.setLineWidth(0.2); doc.line(ml, ph - 10, mr, ph - 10)
        doc.setFontSize(6); doc.setFont('helvetica', 'bold'); doc.setTextColor(...primary); doc.text('KES LAKAY', ml, ph - 6)
        doc.setFont('helvetica', 'normal'); doc.setTextColor(...muted); doc.text('Page ' + p + ' / ' + totalPages, pw / 2, ph - 6, { align: 'center' })
        var now = new Date(); doc.text(now.toLocaleDateString('fr-FR') + ' ' + now.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }), mr, ph - 6, { align: 'right' })
      }
      doc.save('rapport_agents.pdf')
    },

    exportExcel() {
      var self = this
      var XLSX = require('xlsx')
      var biz = {}; try { biz = JSON.parse(localStorage.business) || {} } catch (e) { biz = {} }
      var d = self.getDateParams()
      var wsData = [['RAPPORT PAR AGENT'], [biz.name || ''], ['Du ' + d.from + ' au ' + d.to], []]
      var headers = ['Agent', 'Taux (%)', 'Ventes HTG', 'Ventes USD', 'Conversion (' + self.currencyLabel + ')', 'Commission (' + self.currencyLabel + ')']
      wsData.push(headers)
      self.rows.forEach(function (r) { wsData.push([r.name, r.commission, Math.round(r.sales_htg * 100) / 100, Math.round(r.sales_usd * 100) / 100, Math.round(r.conversion * 100) / 100, Math.round(r.calculated_commission * 100) / 100]) })
      var t = self.totals
      wsData.push([]); wsData.push(['TOTAL (' + self.rows.length + ' agents)', '', Math.round(t.htg * 100) / 100, Math.round(t.usd * 100) / 100, Math.round(t.conversion * 100) / 100, Math.round(t.commission * 100) / 100])

      var wb = XLSX.utils.book_new(); var ws = XLSX.utils.aoa_to_sheet(wsData)
      ws['!cols'] = [{ wch: 24 }, { wch: 10 }, { wch: 16 }, { wch: 16 }, { wch: 18 }, { wch: 18 }]
      ws['!autofilter'] = { ref: XLSX.utils.encode_range({ s: { r: 4, c: 0 }, e: { r: 4, c: headers.length - 1 } }) }
      ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 4 } }, { s: { r: 1, c: 0 }, e: { r: 1, c: 4 } }, { s: { r: 2, c: 0 }, e: { r: 2, c: 4 } }]
      for (var r = 5; r < wsData.length; r++) { for (var c = 2; c <= 5; c++) { var cell = ws[XLSX.utils.encode_cell({ r: r, c: c })]; if (cell && typeof cell.v === 'number') { cell.t = 'n'; cell.z = '#,##0.00' } } }
      XLSX.utils.book_append_sheet(wb, ws, 'Agents'); XLSX.writeFile(wb, 'rapport_agents.xlsx')
    },

    async getStores() {
      this.business_id = JSON.parse(localStorage.business).id
      var self = this
      await this.$axios.get('/stores?orderasc=name&business_id=' + this.business_id).then(function (r) { self.stores = r.data })
    },
    async getDevices() {
      this.business_id = JSON.parse(localStorage.business).id
      var self = this
      await this.$axios.get('/devices?business_id=' + this.business_id).then(function (r) { self.devices = r.data }).catch(function () {})
    },
  },

  created() {
    this.filter_rate_id = localStorage.filter_rate_id
    this.load(); this.getStores(); this.getDevices()
  },
}
</script>

<style scoped>
.filter-card { border: 1px solid #e8ecf1 !important; border-radius: 8px !important; box-shadow: 0 1px 3px rgba(0,0,0,0.04) !important; }
.table-card { border: 1px solid #e8ecf1 !important; border-radius: 8px !important; box-shadow: 0 1px 3px rgba(0,0,0,0.04) !important; overflow: hidden; }
.table-responsive { overflow-x: auto; max-height: 600px; overflow-y: auto; }
.report-table { width: 100%; border-collapse: collapse; font-size: 0.8125rem; }
.report-table thead th { position: sticky; top: 0; background: #f8fafc; font-weight: 600; font-size: 0.6875rem; text-transform: uppercase; letter-spacing: 0.05em; color: #64748b; padding: 12px; border-bottom: 2px solid #e8ecf1; white-space: nowrap; z-index: 1; }
.report-table .totals-row th { background: #f1f5f9; color: #1a2332; font-weight: 700; font-size: 0.75rem; border-bottom: 2px solid #cbd5e1; }
.report-table tbody td { padding: 10px 12px; border-bottom: 1px solid #f1f5f9; white-space: nowrap; }
.report-table tbody tr:hover { background-color: rgba(25, 65, 115, 0.03); }
.gap-2 { gap: 4px; }
</style>
